module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <cn-invite-form modal=true first-name={{data.first_name}} last-name={{data.last_name}} email={{data.email}} transpire={{data.transpire}} on-reset=reset on-submit=submit invited=data.has_password title=\"{{'invite.edit' | translate}}\"></cn-invite-form> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite/salary-invite.modal.edit.html
 ** module id = 198
 ** module chunks = 0
 **/